import { HomePage } from 'teacher-ui-client/components/page/home'
import type HomeRoute from 'teacher-ui-client/subscription-type/home/route'
import { usesExternalRostering } from 'teacher-ui-client/helpers/uses-external-rostering'
import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'

interface Signature {
  Args: {
    model: ModelFor<HomeRoute>
  }
}
export const HomeRoutePage: TOC<Signature> = <template>
  <HomePage
    class="grow"
    @currentSchool={{@model.currentSchool}}
    @currentTeacher={{@model.currentTeacher}}
    @subscriptionType={{@model.subscriptionType}}
    @homeschoolMaxVideoUrl={{@model.homeschoolMaxVideoUrl}}
    @scopeName={{@model.scopeName}}
    @scopeId={{@model.scopeId}}
    @utilisation={{@model.subscriptionUtilisation}}
    @isSubco={{@model.isSubco}}
    @subcoForSubscription={{@model.subcoForSubscription}}
    @showClassLogins={{true}}
    @skipEmailConfirmation={{(usesExternalRostering)}}
  />
</template>

export default RouteTemplate(HomeRoutePage)
